import React, { useCallback, useState } from 'react';

import { Box, Tooltip } from '@chakra-ui/react';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const Wrapper = styled(Box)(({ theme, ...props }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '4px 12px',
  borderRadius: '8px',
  '& svg': {
    color: theme.colors.icon['666666'],
  },
  '&:hover': {
    '& svg': {
      color: theme.colors.button.blue.hover,
    },
    '& p': {
      color: theme.colors.button.blue.hover,
    },
  },
  '&.active-styles': {
    background: checkNewNavEnabled() ? theme.colors.functional.CAE8F0 : theme.colors.functional.E6F1FD,
    '& p': {
      color: theme.colors.button.blue.focus,
    },
    '& svg': {
      color: theme.colors.button.blue.focus,
    },
  },
}));

const StyledTextBodyMedium = styled(TextBodyMedium)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const isEllipsisActive = (containerElement) => containerElement?.offsetWidth < containerElement?.scrollWidth;

export const ListItemLeftNav = ({
  RightComponent,
  LeftIconComponent,
  subTitle,
  title,
  onClick,
  active,
  showTitleTooltip = false,
}) => {
  const theme = useTheme();
  const [showTooltip, setShowTooltip] = useState(false);

  const measuredRef = useCallback(
    (node) => {
      if (node !== null && showTitleTooltip) {
        setShowTooltip(isEllipsisActive(node?.firstChild?.firstChild));
      }
    },
    [showTitleTooltip]
  );

  const isLeftComp = !!LeftIconComponent;
  const isRightComp = !!RightComponent;

  const renderLeftIconComponent = () => {
    if (isLeftComp) {
      return <LeftIconComponent boxSize="24px" color={theme.colors.icon.g2} fill="transparent" />;
    }
  };

  const renderTitle = ({ active = false }) => {
    if (title) {
      return (
        <Tooltip label={title} isDisabled={!showTooltip} shouldWrapChildren>
          <StyledTextBodyMedium bold={!!active} color={theme.colors.text.g1}>
            {title}
          </StyledTextBodyMedium>
        </Tooltip>
      );
    }
  };

  const renderOtherInfo = ({ active = false }) => (
    <Box
      ref={measuredRef}
      marginLeft="8px"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      width="100%"
      sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }} // <- to truncate text
    >
      {renderTitle({ active })}
    </Box>
  );

  const handleOnClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return (
    <Wrapper
      className={active ? ' active-styles' : ''}
      onClick={handleOnClick}
      isLeftComp={isLeftComp}
      isRightComp={isRightComp}
      mb={1}
      cursor="pointer"
    >
      <Box
        style={{ marginLeft: 0, alignItems: 'center' }}
        display="flex"
        alignItems={subTitle ? 'unset' : 'center'}
        width="100%"
      >
        {renderLeftIconComponent()}

        {renderOtherInfo({ active })}
      </Box>
    </Wrapper>
  );
};
